<template><section class="r7-section"><div class="r7-container"><h2>{{ $t('platform.bridgeTitle') }}</h2><p>{{ $t('platform.bridgeIntro') }}</p><a href="/student">{{ $t('platform.explore') }}</a></div></section></template>

<script>
export default {
  name: 'MarketSize'
}
</script>

<style scoped>
.market {
  padding: 5rem 2rem;
  background: 
    radial-gradient(circle at 100% 0%, rgba(0, 217, 255, 0.08) 0, transparent 50%),
    radial-gradient(circle at 0% 100%, rgba(138, 43, 226, 0.08) 0, transparent 50%),
    #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.market-analysis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
}

.market-item {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.market-item:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.market-item h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 1rem;
}

.stat {
  margin: 1.5rem 0;
  padding: 1.5rem;
  background: linear-gradient(135deg, rgba(0, 217, 255, 0.15), rgba(0, 102, 255, 0.1));
  border-radius: 8px;
}

.number {
  display: block;
  font-size: 2rem;
  font-weight: 800;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
}

.stat p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  margin: 0;
}

.market-item p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95rem;
  line-height: 1.6;
}

.market-positioning {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, rgba(0, 102, 255, 0.1), rgba(138, 43, 226, 0.1));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
}

.market-positioning h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 1rem;
}

.market-positioning p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  line-height: 1.8;
  margin: 0.75rem 0;
}

.market-positioning strong {
  color: #00D9FF;
  font-weight: 700;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .market {
    padding: 3rem 1.5rem;
  }

  .number {
    font-size: 1.5rem;
  }
}
</style>
